export default (function ($) {

    var _instance = {};

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).on('ready', function () {
            $(document).on("click", ".accordion-toggle", function (e) {
                e.preventDefault();

                var $this = $(this);

                if ($this.parent().hasClass('active')) {
                    $this.parent().removeClass('active');
                } else {
                    $this.parent().toggleClass('active');
                }
            });
        });
    }

    return _instance;

})(jQuery)